exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n#whitelist-list {\n\tmin-width: 262px;\n}\n", ""]);
